import { useTranslation } from "react-i18next";
import { StringKeys } from "../../../../resources/strings/StringKeys";

export const useAssetConditions = () => {
    const { t } = useTranslation();

    const conditions = {
        new: t(StringKeys.NEW),
        fair: t(StringKeys.FAIR),
        used: t(StringKeys.USED),
        poor: t(StringKeys.POOR),
        retired: t(StringKeys.RETIRED)
    };

    return {
        getTranslatedConditions: () => Object.entries(conditions).map(([key, value]) => ({ key, value })),
        getConditionKey: (translatedValue) =>
            Object.keys(conditions).find((key) => conditions[key] === translatedValue)?.toLowerCase(),
        getTranslatedValue: (key) => conditions[key?.toLowerCase()] || key,
    };
};
